import ArtworkCard from './ArtworkCard.jsx';

export default function GalleryGrid({ artworks, onOpen }) {
  return (
    <section className="gallery-grid">
      {artworks.map((artwork, index) => (
        <ArtworkCard
          key={artwork.id}
          artwork={artwork}
          onOpen={(element) => onOpen(artwork, index, element)}
        />
      ))}
    </section>
  );
}
